/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Phone_NumberInputs */

const en_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const de_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const fr_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const es_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const it_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const nl_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const pl_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const fi_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const da_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

const sv_impressum_phone_number = /** @type {(inputs: Impressum_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+49 15563 148598`)
};

/**
* | output |
* | --- |
* | "+49 15563 148598" |
*
* @param {Impressum_Phone_NumberInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_phone_number = /** @type {((inputs?: Impressum_Phone_NumberInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Phone_NumberInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_phone_number(inputs)
	if (locale === "fr") return fr_impressum_phone_number(inputs)
	if (locale === "es") return es_impressum_phone_number(inputs)
	if (locale === "it") return it_impressum_phone_number(inputs)
	if (locale === "nl") return nl_impressum_phone_number(inputs)
	if (locale === "pl") return pl_impressum_phone_number(inputs)
	if (locale === "fi") return fi_impressum_phone_number(inputs)
	if (locale === "da") return da_impressum_phone_number(inputs)
	if (locale === "sv") return sv_impressum_phone_number(inputs)
	return en_impressum_phone_number(inputs)
});